
import { useTranslation } from "react-i18next";
import styles from "./PartSurveyAdminUsed.module.scss";
import { useEffect, useState } from "react";

import PartSurveyItemAdminUse from './components/PartSurveyItemAdminUse';
import { getSurveyUserDetailData, StartSurveyUser, getSurveyUser } from "service/SurveyService";
import { useLocation, useNavigate } from 'react-router-dom'
import userInfo from "utils/userInfo";
import { Button, Layout } from "components";
import moment from 'moment';
import Moment from 'react-moment'
import Notification from "utils/Notifications";

const PartSurveyUsed = ({setShowUserInfoForm, data, usedata, setRender}) => {
  const { t } = useTranslation("common");



  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });


  const formatDate = (dateString) => {
    const date = moment(dateString, 'DD.MM.YYYY HH:mm');
    const today = moment();

    if (date.isSame(today, 'day')) {
      return date.format('Сегодня HH:mm');
    }
    else if (date.isSame(today, 'year')) {
      return date.format('DD MMMM HH:mm')
    }
    else {
      return date.format('DD MMMM YYYY HH:mm');
    }
  };

  return (

      <div className={styles.test_card}>
        <div style={{ display: 'flex', alignItems: 'start', flexDirection: 'column', justifyContent: 'start', width: '100%' }}>
          <div className={styles["test-app"]}>
           
            <Button
              className={styles.open_btn}
              onClick={() => setShowUserInfoForm(null)}
            >
              {t('surveys.adminUse.return')}
            </Button>
          </div>
          
        </div>
    
  
        
          <>
            {data?.map((item, index) =>
              <PartSurveyItemAdminUse
                item={item}
                item_selected={usedata?.userusetsurvey_employee_tsurveys
                  ?.filter(testItem => testItem.part === item.id || 0)
                  ?.map(filteredItem => filteredItem.part || "Default Value")}
                item_selected_data={usedata?.userusetsurvey_employee_tsurveys
                  ?.filter(testItem => testItem.part === item.id)  
                }
                index={index}
                
                setRender={setRender}
              />


            )}
          </>
        
          <Notification notify={notify} setNotify={setNotify} />
      </div >
    
 
  );
};

export default PartSurveyUsed;
